import React from 'react';
import {Field} from 'redux-form';

import {SearchField} from 'components/Fields';

export const buildRoomSelectizeOption = room => ({
  label: room.label,
  value: room.id,
  object: room
});

const SearchRoomField = ({
  onChange,
  rooms,
  disabled,
  warn,
  name = 'room',
  validate = [],
  isLoading = false
}: any) => (
  <Field
    name={name}
    validate={validate}
    component={SearchField}
    onChange={onChange}
    options={rooms.map(buildRoomSelectizeOption)}
    disabled={rooms.length <= 1 || disabled || isLoading}
    warn={warn || []}
    isLoading={isLoading}
  />
);

export default SearchRoomField;
